// Client Configuration - Easy to update content
export const siteConfig = {
  // Company Information
  companyName: "Musespace",
  tagline: "Architecture & Interior Design",
  description:
    "Professional architecture and interior design services that transform spaces into beautiful, functional environments.",

  // Contact Information
  contact: {
    email: "musespace.j@gmail.com",
    address: "45QF+F74 Chennai, Tamil Nadu, India",
    workingHours: "Mon - Fri: 9:00 AM - 6:00 PM",
  },

  // Social Media Links
  socialMedia: {
    instagram: "https://www.instagram.com/musespace._/",
  },

  // Services
  services: [
    {
      title: "Architecture Design",
      description:
        "Complete architectural solutions from concept to completion",
      icon: "🏗️",
    },
    {
      title: "Interior Design",
      description: "Beautiful and functional interior spaces",
      icon: "🏠",
    },
    {
      title: "Space Planning",
      description: "Optimal space utilization and flow",
      icon: "📐",
    },
    {
      title: "Project Management",
      description: "End-to-end project coordination and execution",
      icon: "📋",
    },
  ],

  // About Section
  about: {
    title: "About Musespace",
    description:
      "We are passionate about creating spaces that inspire, function, and delight. Our team of experienced architects and interior designers work closely with clients to bring their vision to life.",
    highlights: [
      "4+ Years of Experience",
      "20+ Projects Completed",
      "Quality Design Focus",
      "Client Satisfaction Focus",
    ],
  },

  // Portfolio Categories
  portfolioCategories: [
    "All",
    "Residential",
    "Commercial",
    "Hospitality",
    "Interior Design",
  ],
};

export default siteConfig; 